import React from "react";
import { motion } from "framer-motion";

// Icons map moved outside for optimization
const iconsMap = {
  HTML: <i className="devicon-html5-plain colored text-2xl"></i>,
  CSS: <i className="devicon-css3-plain colored text-2xl"></i>,
  JavaScript: <i className="devicon-javascript-plain colored text-2xl"></i>,
  React: <i className="devicon-react-original colored text-2xl"></i>,
  "Node.js": <i className="devicon-nodejs-plain colored text-2xl"></i>,
  Express: <i className="devicon-express-original text-2xl"></i>,
  PostgreSQL: <i className="devicon-postgresql-plain colored text-2xl"></i>,
  MySQL: <i className="devicon-mysql-plain colored text-2xl"></i>,
  Docker: <i className="devicon-docker-plain colored text-2xl"></i>,
  Git: <i className="devicon-git-plain colored text-2xl"></i>,
  Vercel: <span className="text-2xl">⚡</span>,
  Postman: <span className="text-2xl">📬</span>,
};

const SkillsPage = ({ skills }) => {
  return (
    <section id="skills" className="px-6 py-20 max-w-6xl mx-auto">
      <motion.h2
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-4xl font-bold text-gray-900 dark:text-white mb-10"
      >
        Stack
      </motion.h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5 sm:gap-6">
        {skills.map((skill, i) => (
          <motion.div
            key={skill}
            className="relative group flex justify-center items-center 
                       p-5 rounded-xl backdrop-blur-md border 
                       border-gray-200/40 dark:border-gray-700 
                       bg-white/60 dark:bg-slate-900/50 shadow-sm
                       transition duration-300 cursor-pointer
                       hover:shadow-lg hover:border-gray-300 dark:hover:border-gray-500"
            style={{ WebkitBackdropFilter: "blur(10px)" }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: i * 0.05 }}
            viewport={{ once: true }}
          >
            {/* Tooltip */}
            <span className="absolute -top-8 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-all duration-200 pointer-events-none">
              {skill}
            </span>

            <motion.div
              whileHover={{ scale: 1.15, rotate: 4 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="text-teal-500"
              aria-label={skill}
            >
              {iconsMap[skill] || <span className="text-lg">🛠️</span>}
            </motion.div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default SkillsPage;
